module.exports = __webpack_public_path__ + "static/media/white.caecb621.png";